import styled from 'styled-components';

const LikertScaleWrapper = styled.div`
  .likert-scale-input {
    flex: 1;
  }
`;

export default LikertScaleWrapper;
